import { useMemo } from 'react'

import EntitiesSelector from './EntitiesSelector'
import { useSelector } from 'react-redux'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { StudentStatusLabels } from '../../../utils/entities/student'

const StudentStatusSelector = ({ className = '', disabled, multiple = 'default', placeholder, style = {}, tagPlaceholder, values, onChange }) => {
  const t = useSelector(selectTranslate)

  const studentStatusOptions = useMemo(() => StudentStatusLabels.map(status => ({
    label: t('student_status_codes.' + status.toLowerCase()),
    value: status
  })), [t])

  return (
    <EntitiesSelector
      className={className}
      disabled={disabled}
      entityOptions={studentStatusOptions}
      multiple={multiple}
      placeholder={placeholder}
      showSearch
      style={style}
      tagPlaceholder={tagPlaceholder}
      values={values}
      onChange={onChange}
    />
  )
}

export default StudentStatusSelector
